import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollReveal from '@/components/base/ScrollReveal';
import ParticleBackground from '@/components/base/ParticleBackground';

export default function Contact() {
  return (
    <div className="ui-page">
      <Navbar />
      <main className="pt-20">
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background-900/40 to-transparent z-[1]"></div>
          <ParticleBackground compact />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <div className="text-center mb-16">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
                    <span className="w-1 h-1 rounded-full bg-primary-500"></span>
                    <span className="text-primary-300 text-xs font-medium tracking-wider whitespace-nowrap">Contact Us</span>
                  </div>
                  <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-primary-500 mb-6">联系我们</h1>
                  <p className="text-secondary-400 text-lg max-w-2xl mx-auto">期待与您沟通交流，共建文化数字产业协作生态</p>
                </div>
              </ScrollReveal>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
                <ScrollReveal>
                  <div className="group bg-background-900/50 rounded-2xl border border-primary-500/15 p-8 md:p-10 h-full hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]">
                    <h2 className="font-heading text-2xl font-bold text-foreground-50 mb-8 group-hover:text-primary-500 transition-colors duration-500">联系方式</h2>

                    <div className="space-y-6">
                      <div className="flex items-start gap-4 group/item hover:translate-x-1 transition-transform duration-300">
                        <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover/item:bg-primary-500/20 group-hover/item:scale-110 transition-all duration-500">
                          <i className="ri-building-2-line text-primary-500 text-xl"></i>
                        </div>
                        <div>
                          <h4 className="text-foreground-50 font-medium text-sm mb-1">企业名称</h4>
                          <p className="text-secondary-400 text-sm">晋铧叙梦（山西）文化科技有限公司</p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 group/item hover:translate-x-1 transition-transform duration-300">
                        <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover/item:bg-primary-500/20 group-hover/item:scale-110 transition-all duration-500">
                          <i className="ri-team-line text-primary-500 text-xl"></i>
                        </div>
                        <div>
                          <h4 className="text-foreground-50 font-medium text-sm mb-1">所属联盟</h4>
                          <p className="text-secondary-400 text-sm">冯全普·县域AI+OPC联盟核心成员单位</p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 group/item hover:translate-x-1 transition-transform duration-300">
                        <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover/item:bg-primary-500/20 group-hover/item:scale-110 transition-all duration-500">
                          <i className="ri-map-pin-line text-primary-500 text-xl"></i>
                        </div>
                        <div>
                          <h4 className="text-foreground-50 font-medium text-sm mb-1">办公地址</h4>
                          <p className="text-secondary-400 text-sm">山西省晋中市榆次区巨燕商务广场</p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 group/item hover:translate-x-1 transition-transform duration-300">
                        <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover/item:bg-primary-500/20 group-hover/item:scale-110 transition-all duration-500">
                          <i className="ri-phone-line text-primary-500 text-xl"></i>
                        </div>
                        <div>
                          <h4 className="text-foreground-50 font-medium text-sm mb-1">业务热线</h4>
                          <p className="text-secondary-400 text-sm">（预留填写）</p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 group/item hover:translate-x-1 transition-transform duration-300">
                        <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover/item:bg-primary-500/20 group-hover/item:scale-110 transition-all duration-500">
                          <i className="ri-mail-line text-primary-500 text-xl"></i>
                        </div>
                        <div>
                          <h4 className="text-foreground-50 font-medium text-sm mb-1">招聘邮箱</h4>
                          <p className="text-secondary-400 text-sm">（预留填写）</p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-8 pt-8 border-t border-primary-500/10">
                      <h4 className="text-foreground-50 font-medium text-sm mb-4">关注我们</h4>
                      <div className="flex gap-3">
                        {[
                          { icon: 'ri-wechat-line', label: '公众号' },
                          { icon: 'ri-tiktok-line', label: '抖音' },
                          { icon: 'ri-video-line', label: '视频号' },
                        ].map((item) => (
                          <div key={item.label} className="flex flex-col items-center gap-2 group/social">
                            <div className="w-12 h-12 rounded-xl bg-background-800 flex items-center justify-center text-secondary-400 hover:text-primary-500 hover:bg-primary-500/10 hover:scale-110 transition-all duration-500 cursor-pointer hover:shadow-[0_0_15px_rgba(180,140,80,0.2)]">
                              <i className={`${item.icon} text-xl`}></i>
                            </div>
                            <span className="text-secondary-500 text-[10px] group-hover/social:text-secondary-400 transition-colors duration-300">{item.label}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </ScrollReveal>

                <ScrollReveal>
                  <div className="group bg-background-900/50 rounded-2xl border border-primary-500/15 overflow-hidden h-full min-h-[400px] hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3134.494413113587!2d112.7235!3d37.6872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQxJzEzLjkiTiAxMTLCsDQzJzI0LjYiRQ!5e0!3m2!1szh-CN!2scn!4v1690000000000"
                      width="100%"
                      height="100%"
                      style={{ border: 0, minHeight: '400px' }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="晋铧叙梦办公地址"
                      className="w-full h-full"
                    ></iframe>
                  </div>
                </ScrollReveal>
              </div>

              <ScrollReveal>
                <div className="group text-center bg-background-900/50 rounded-2xl border border-primary-500/15 p-10 md:p-14 hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]">
                  <h3 className="font-heading text-2xl font-bold text-foreground-50 mb-4 group-hover:text-primary-500 transition-colors duration-500">在线咨询</h3>
                  <p className="text-secondary-400 text-sm mb-8 max-w-xl mx-auto">如需合作咨询、业务洽谈或其他问题，欢迎联系我们</p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <a href="/cooperation" className="group/btn inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-foreground-50 font-medium rounded-full text-sm hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-[0_0_15px_rgba(200,120,50,0.3)]">
                      招商合作咨询
                      <div className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover/btn:translate-x-1">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </a>
                    <a href="/recruit" className="group/btn inline-flex items-center gap-2 px-8 py-3.5 border border-primary-500/50 text-primary-500 font-medium rounded-full text-sm hover:bg-primary-500/10 transition-all duration-300 whitespace-nowrap cursor-pointer">
                      加入我们
                      <div className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover/btn:translate-x-1">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
